// event.key - standard
export const KEYS = {
  ESC: 'Escape',
  SPACE: ' ',
  ENTER: 'Enter',
  LEFT: 'ArrowLeft',
  UP: 'ArrowUp',
  RIGHT: 'ArrowRight',
  DOWN: 'ArrowDown',
  TAB: 'Tab',
  HOME: 'Home',
  END: 'End',
};

// event.code - limited support
export const KEYCODES = {
  ESC: 'Escape',
  SPACE: 'Space',
  LEFT: 'ArrowLeft',
  UP: 'ArrowUp',
  RIGHT: 'ArrowRight',
  DOWN: 'ArrowDown',
  ENTER: 'Enter',
  TAB: 'Tab',
  HOME: 'Home',
  END: 'End',
};
